<div class="order-details__list-item">
  <div class="detail-left-col">
    {{ 'FRONTEND.SALES_UI.CONTRACT_START' | translate }}
  </div>
  <div class="order-details__list-item__value">
    <div class="item_container">
      <ng-container *ngIf="isEditing; else display">
        <div class="date-input-wrapper">
          <glxy-form-field class="date-input" [bottomSpacing]="'none'">
            <glxy-label>{{ 'FRONTEND.SALES_UI.CONTRACT_START_FORMAT' | translate }}</glxy-label>
            <input
              matInput
              [matDatepicker]="picker"
              name="date"
              [min]="minDate"
              [value]="requestedActivation"
              [(ngModel)]="requestedActivation"
              (click)="picker.open()"
              required
            />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <glxy-hint>
              {{ 'FRONTEND.SALES_UI.CONTRACT_START_HINT' | translate }}
            </glxy-hint>
          </glxy-form-field>
        </div>

        <button mat-flat-button color="primary" (click)="updateRequestedActivation()">
          <glxy-button-loading-indicator [isLoading]="updatingRequestedActivation">
            {{ 'FRONTEND.SALES_UI.SAVE' | translate }}
          </glxy-button-loading-indicator>
        </button>
      </ng-container>
    </div>
  </div>
</div>
<ng-template #display>
  <span class="date">{{ formatDate(requestedActivation) }}</span>
  <button *ngIf="editable" mat-icon-button (click)="edit()">
    <mat-icon>edit</mat-icon>
  </button>
</ng-template>
